import { Button, Tooltip, useComputedColorScheme } from '@mantine/core';
import React, { forwardRef } from 'react';
import { getOutlineControlProps } from 'utils/buttonUtils';

interface TableActionButtonProps {
  children?: any;
  onClick?: () => any;
  leftIcon: any;
  disabled?: boolean;
  isLoading?: boolean;
  dataTestId?: string;
}

export const TableActionButton = forwardRef<
  HTMLButtonElement,
  TableActionButtonProps
>(
  (
    {
      children,
      onClick,
      leftIcon,
      disabled = false,
      isLoading = false,
      dataTestId = null,
    },
    ref
  ) => {
    const computedColorScheme = useComputedColorScheme('dark');
    return (
      <React.Fragment>
        <Tooltip
          label="Loading..."
          position="top"
          withArrow
          disabled={!isLoading}
        >
          <Button
            ref={ref}
            onClick={onClick}
            leftSection={leftIcon}
            radius="md"
            disabled={disabled}
            data-variant="create"
            {...getOutlineControlProps(computedColorScheme, disabled)}
            data-testid={dataTestId ? dataTestId : ''}
          >
            {children ? children : ''}
          </Button>
        </Tooltip>
      </React.Fragment>
    );
  }
);
